var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-scroll-view",
        [
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "4" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          items: _vm.alignItems,
                          label: _vm.$ct("image-horizontal-align"),
                        },
                        model: {
                          value: _vm.data.HorizontalAlign,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "HorizontalAlign", $$v)
                          },
                          expression: "data.HorizontalAlign",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "4" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          items: _vm.alignItems,
                          label: _vm.$ct("image-vertical-align"),
                        },
                        model: {
                          value: _vm.data.VerticalAlign,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "VerticalAlign", $$v)
                          },
                          expression: "data.VerticalAlign",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "4" } },
                    [
                      _c("app-color-picker", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("background-color"),
                        },
                        model: {
                          value: _vm.data.BackgroundColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "BackgroundColor", $$v)
                          },
                          expression: "data.BackgroundColor",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "3" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("padding-left"),
                          decimals: 0,
                        },
                        model: {
                          value: _vm.data.PaddingLeft,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "PaddingLeft", $$v)
                          },
                          expression: "data.PaddingLeft",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "3" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("padding-right"),
                          decimals: 0,
                        },
                        model: {
                          value: _vm.data.PaddingRight,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "PaddingRight", $$v)
                          },
                          expression: "data.PaddingRight",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "3" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("padding-top"),
                          decimals: 0,
                        },
                        model: {
                          value: _vm.data.PaddingTop,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "PaddingTop", $$v)
                          },
                          expression: "data.PaddingTop",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "3" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("padding-bottom"),
                          decimals: 0,
                        },
                        model: {
                          value: _vm.data.PaddingBottom,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "PaddingBottom", $$v)
                          },
                          expression: "data.PaddingBottom",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("image-hide-card") },
                        model: {
                          value: _vm.data.HideCardBorder,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "HideCardBorder", $$v)
                          },
                          expression: "data.HideCardBorder",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-file-upload-drop-and-progress", {
                        attrs: {
                          sending: _vm.uploadingImage,
                          "max-size": 10e6,
                          "allowed-extensions": _vm.allowedExtensions,
                          label: _vm.$ct("drop-image-to-upload"),
                          disabled: _vm.uploadDisabled,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.onImageDrop($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list",
            _vm._l(_vm.images, function (img) {
              return _c(
                "w-list-item",
                {
                  key: img.ID,
                  attrs: { disabled: _vm.data.AWSImageToken == img.Token },
                  on: {
                    click: function ($event) {
                      return _vm.selectImage(img)
                    },
                  },
                },
                [
                  _c("w-list-item-icon", [
                    _c("img", {
                      staticClass: "image-preview",
                      attrs: { src: img.getUrl(), alt: img.Name },
                    }),
                  ]),
                  _c("w-list-item-text", [
                    _vm._v(" " + _vm._s(img.Name) + " "),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("delete-image"),
                              expression: "$ct('delete-image')",
                            },
                          ],
                          staticClass: "danger",
                          attrs: {
                            disabled: _vm.data.AWSImageToken == img.Token,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteImage(img)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check", disabled: _vm.confirmDisabled },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }